import { type PayoutTicket } from '~/entities/payout';
import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';

export const openTicketModal = (ticket: PayoutTicket) =>
    openResponsiveModal({
        modalId: MODALS.PAYOUT_TICKET_MANAGEMENT,
        innerProps: {
            ticket,
            onReslove: () => closeResponsiveModal(MODALS.PAYOUT_TICKET_MANAGEMENT),
        },
        modal: MODALS.PAYOUT_TICKET_MANAGEMENT,
        title: 'Управление заявкой',
    });
